import { useState } from 'react'
import styled from 'styled-components'
import { Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import useAccountChange from '../../hooks/useAccountChange'
import { RequestService, STATUSES } from '../../services/RequestService'
import { useSnackbar } from '../../hooks'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f1f3f5;
  padding: 32px 48px;

  h2 {
    margin-top: 20px;
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #d6d7db;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 24px 0 0 0;
  gap: 8px;

  & > .MuiTextField-root {
    margin-bottom: 16px;
  }
`

const AccountChange = () => {
  const { data: adminChangeData } = useAccountChange()
  const { successSnackbar, errorSnackbar } = useSnackbar()

  const [accountForm, setAccountForm] = useState({
    current_account_id: ''
  });

  const handleAccountChange = (event) => {
    setAccountForm({
      current_account_id: event.target.value
    });
  };

  const handleAccountSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await RequestService.updateUserAccount(accountForm);

      if (response.status === STATUSES.SUCCESS) {
        successSnackbar({ text: 'Conta atualizada com sucesso' });

        setAccountForm(prev => ({
          ...prev,
          current_account_id: accountForm.current_account_id
        }));
      } else {
        errorSnackbar({ text: 'Falha ao atualizar conta' });
      }
    } catch (e) {
      errorSnackbar({ text: 'Falha ao atualizar conta' });
    }
  };

  return (
    <Container>
      {/* Account Selection Form */}
      <h2>Seleção de Conta</h2>
      <FormContainer as="form" onSubmit={handleAccountSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>{adminChangeData?.currentAccount?.name}</InputLabel>
          <Select
            name="current_account_id"
            value={adminChangeData?.currentAccount?.id}
            onChange={handleAccountChange}
            label='Account'
          >
            <MenuItem value="">Selecione uma conta</MenuItem>
            {adminChangeData?.accountList?.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                {account.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!accountForm.current_account_id}
        >
          Alterar Conta Logada
        </Button>
      </FormContainer>

    </Container>
  )
}

export default AccountChange
